import IconButton from '../../../../components/atoms/button/IconButton';
import Input from '../../../../components/atoms/input';
import { SurveyAlternativeData } from '../../../../types/contentTypes';

interface SurveyAlternativeProps {
  alternative: SurveyAlternativeData;
  index: number;
  onTextChange: (value: string) => void;
  onDelete?: () => void;
  className?: string;
}

export default function SurveyAlternative({
  alternative,
  index,
  onTextChange,
  onDelete,
  className,
}: SurveyAlternativeProps) {
  return (
    <div className={`answer-alternative ${onDelete ? 'show-delete' : ''} ${className}`}>
      <Input
        type="text"
        value={alternative.text}
        onChange={({ target: { value } }) => onTextChange(value)}
        placeholder={`Alternative ${index + 1}`}
        required={true}
      />
      {onDelete && <IconButton icon="close" visualType="no-bg" onClick={onDelete} />}
    </div>
  );
}
